export type Voice = {
  quote: string
  author: string
  source: string
}

/**
 * VOC real (ficha DPS64): frases textuales de mecánicos en foros públicos de
 * reparación de motores pequeños, con fecha. NO son reseñas del producto y la
 * página lo aclara. Fuentes completas en la ficha de producto (sección VOC).
 */
export const leaderVoices: Voice[] = [
  {
    quote: 'this surging stumps me',
    author: 'A tech with a twin-cylinder rider that keeps surging',
    source: 'Lawn mower repair forum, 2021',
  },
  {
    quote: 'What am I missing???',
    author: 'The same tech, after cleaning the carb',
    source: 'Lawn mower repair forum, 2021',
  },
  {
    quote: 'surging the same exact way again',
    author: 'After the carb was cleaned and refitted',
    source: 'Lawn mower repair forum, 2021',
  },
]

export const moreLeaderVoices: Voice[] = [
  {
    quote: 'before I pull the last of my hair out',
    author: 'A mechanic after replacing the carb, pump, filter, lines and plugs',
    source: 'Small engine repair forum, 2022',
  },
  {
    quote: 'Ok, so Im baffled.',
    author: 'A tech trying to set a governor spring',
    source: 'Lawn mower repair forum, 2014',
  },
  {
    quote: 'a customer doesn’t have to pay, even if there is a balance due.',
    author: 'A shop owner on equipment left behind for 120 days',
    source: 'Lawn mower repair forum, 2018',
  },
]
